export default {
    debug: false,
    displaySizes: {
        desktop: 1299,
        tablet: 991,
        smartphone: 767
    }
}
